export default __webpack_public_path__ + "static/Scroll-Image---Concrete-Parking-Lot-Removal-5715e650b5e00c4d25e40b0e99a5b5d7.jpg";